function ChartPie(chart, chartDataSelect, chartContainer) {
  // ################################################### COLORS #############################################################
  var title = chartContainer.querySelector(".titleContainer > h5");
  var subTitle = chartContainer.querySelector(".titleContainer > h6");
  var legend = chartContainer.querySelector(".legend");
  legend.innerHTML = "";
  legend = legend.appendChild(document.createElement("ul"));
  var additionalInformation = chartContainer.querySelector(
    ".additionalInformation"
  );
  // #########################################################################################################################
  var selected = chartDataSelect.getSelected();
  var lastDeal;

  var data = [];
  var labels = [];
  var backgroundColor = [];

  if (selected.PARTNERGROUP) {
    title.innerText = lng.get("dashboard-customers");

    var customers;
    var edges = chartDataSelect.getEdgesFromSelectors();
    var id;
    var type;
    var typeName;

    if (selected.EMPLOYEE) {
      id = selected.EMPLOYEE;
      type = ChartDataX.EMPLOYEE;
      typeName = lng.get("employee");
    } else if (selected.PARTNER) {
      id = selected.PARTNER;
      type = ChartDataX.PARTNER;
      typeName = lng.get("partner");
    } else {
      id = selected.PARTNERGROUP;
      type = ChartDataX.PARTNERGROUP;
      typeName = lng.get("partnerGroup");
    }

    if (id === ChartDataSelectX.ALL) {
      subTitle.innerText = lng.get("dashboard-per") + " " + typeName;
      var pGpes = chartDataSelect.data.getArrayData(type, edges);

      pGpes.sort(function (a, b) {
        if (a[1] < b[1]) return -1;
        if (b[1] < a[1]) return 1;
        return 0;
      });

      customers = chartDataSelect.data.getArrayData(ChartDataX.CUSTOMER, edges);
      for (let i = 0; i < pGpes.length; ++i) {
        var _id = pGpes[i][0];
        var name = pGpes[i][1];
        var color = pGpes[i][2];

        var _edges = SetX.intersection(
          chartDataSelect.data.getNameColorEdgesFromId(_id)[2],
          edges
        );
        var customers = chartDataSelect.data.getArrayData(
          ChartDataX.CUSTOMER,
          _edges
        );
        customers.sort(function (a, b) {
          if (a[1] < b[1]) return 1;
          if (b[1] < a[1]) return -1;
          return 0;
        });
        if (customers.length > 0) {
          lastDeal = new moment(customers[0][1]);
        }

        data.push(customers.length);
        labels.push(name);
        backgroundColor.push(color);

        const legendItem = createLegendItem(name, color, customers);
        legendItem.addEventListener("click", function (e) {
          const hidden = (chart.getDatasetMeta(0).data[i].hidden =
            !chart.getDatasetMeta(0).data[i].hidden);
          chart.update();
          e.target.parentElement.querySelector("span").style =
            "text-decoration:" + (hidden ? "line-through" : "none") + ";";
        });

        legend.appendChild(legendItem);
      }
    } else {
      var dataFromId = chartDataSelect.data.getNameColorEdgesFromId(id);
      var name = dataFromId[0];
      var color = dataFromId[1];
      var _edges = SetX.intersection(dataFromId[2], edges);

      subTitle.innerText = lng.get("dashboard-from") + " " + name;

      const customers = chartDataSelect.data.getArrayData(
        ChartDataX.CUSTOMER,
        _edges
      );
      customers.sort(function (a, b) {
        if (a[1] < b[1]) return 1;
        if (b[1] < a[1]) return -1;
        return 0;
      });
      if (customers.length > 0) {
        lastDeal = new moment(customers[0][1]);
      }

      if (type === "EMPLOYEE" && selected.FORM === "-2") {
        // No employee is selected -> show by form
        const allFormIds = new Set(customers.map((customer) => customer[2]));
        allFormIds.forEach((formId) => {
          const filteredData = customers.filter(
            (customer) => customer[2] === formId
          );
          const formData = chartDataSelect.data.mInitForm.get(formId);
          data.push(filteredData.length);
          labels.push(formData.r[0].name);
          backgroundColor.push(formData.color);

          const legendItem = createLegendItem(
            formData.r[0].name,
            formData.color,
            filteredData
          );
          legend.appendChild(legendItem);
        });
      } else if (type === "EMPLOYEE" && selected.FORM !== "-2") {
        // Employee is selected -> show by location
        const allLocationIds = new Set(
          customers.map((customer) => customer[3])
        );
        allLocationIds.forEach((locationId) => {
          const filteredData = customers.filter(
            (customer) => customer[3] === locationId
          );
          const locationData =
            chartDataSelect.data.mInitLocation.get(locationId);
          data.push(filteredData.length);
          labels.push(locationData.r[0].name);
          backgroundColor.push(locationData.color);

          const legendItem = createLegendItem(
            locationData.r[0].name,
            locationData.color,
            filteredData
          );
          legend.appendChild(legendItem);
        });
      } else {
        data.push(customers.length);
        labels.push(name);
        backgroundColor.push(color);

        const legendItem = createLegendItem(name, color, customers);
        legendItem.addEventListener("click", function (e) {
          const hidden = (chart.getDatasetMeta(0).data[0].hidden =
            !chart.getDatasetMeta(0).data[0].hidden);
          chart.update();
          e.target.parentElement.querySelector("span").style =
            "text-decoration:" + (hidden ? "line-through" : "none") + ";";
        });

        legend.appendChild(legendItem);
      }
    }
  } else {
    title.innerText = "";
    subTitle.innerText = "";
  }

  chart.chart.config.data = {
    datasets: [
      {
        data: data,
        backgroundColor: backgroundColor,
        label: "",
      },
    ],
    labels: labels,
  };

  additionalInformation.innerHTML = `<i class="material-icons">history</i>
        <span>
            ${
              lastDeal
                ? lng.get("dashboard-last-customer") +
                  ": " +
                  lastDeal.format("LLLL")
                : lng.get("dashboard-no-customers")
            }
        </span>`;
  chart.update();

  function createLegendItem(name, color, legendData) {
    const legendItem = document.createElement("li");
    const legendItemIcon = document.createElement("i");
    legendItemIcon.setAttribute("class", "material-icons");
    legendItemIcon.style.color = color;
    legendItemIcon.innerText = "fiber_manual_record";
    const legendItemText = document.createElement("span");
    legendItemText.innerText = name + " [" + legendData.length + "]";

    legendItem.appendChild(legendItemIcon);
    legendItem.appendChild(legendItemText);
    return legendItem;
  }
}
